import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import en from './locales/en.json'
import tr from './locales/tr.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      tr: { translation: tr },
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  })

// F3.I18N-2: Keep <html lang> in sync with current language
const applyHtmlLang = (lng: string | undefined) => {
  if (typeof document === 'undefined') return
  const short = (lng || 'en').split('-')[0]
  document.documentElement.lang = short
  // Set direction (future-proof for RTL languages)
  document.documentElement.dir = ['ar', 'he', 'fa', 'ur'].includes(short) ? 'rtl' : 'ltr'
}
applyHtmlLang(i18n.language)
i18n.on('languageChanged', applyHtmlLang)

export default i18n
